import React, {Component} from 'react';
import perform_request from '../../../provider/NetworkProvider';
import {createRoot} from "react-dom/client";
import AuthLayout from "../../../layout/AuthLayout";

const container = document.getElementById('react-app-container');

class AdminLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: {
                email: '',
                password: ''
            },
            showPassword: false,
            errors: {},
            isLoading: false,
            messages: []
        };
    }

    componentDidMount() {
        // Prevent back button
        history.pushState(null, null, location.href);
        window.onpopstate = function () {
            history.go(1);
        };

        // Check for session messages
        const urlParams = new URLSearchParams(window.location.search);
        const success = urlParams.get('success');
        const message = urlParams.get('message');

        if (success) {
            this.setState({messages: [{level: 'success', message: success}]});
        }
        if (message) {
            this.setState({messages: [{level: 'danger', message: message}]});
        }
    }

    handleInputChange = (e) => {
        const {name, value} = e.target;
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                [name]: value
            }
        }));

        // Clear error when user starts typing
        if (this.state.errors[name]) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    [name]: ''
                }
            }));
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({isLoading: true, errors: {}});

        perform_request('post', 'login', false, this.state.formData).then(response => {
            if (response.body.success) {
                window.location.href = response.body.data.redirect || '/';
            } else {
                this.setState({errors: response.body.data || {}});
                if (response.body.data.message) {
                    this.setState({messages: [{level: 'danger', message: response.body.data.message}]});
                }
            }
        }).catch(error => {
            this.setState({
                messages: [{
                    level: 'danger',
                    message: error.message ? error.error : 'An error occurred during login. Please try again.'
                }]
            });
        }).finally(() => {
            this.setState({isLoading: false});
        })
    };

    togglePasswordVisibility = (e) => {
        e.preventDefault();
        this.setState(prevState => ({
            showPassword: !prevState.showPassword
        }));
    };

    getPasswordResetUrl = () => {
        return '/password/reset';
    };

    render() {
        const {formData, showPassword, errors, isLoading, messages} = this.state;

        return (
            <AuthLayout>
                <h2>Admin Login</h2>
                <p className="mb-5">Log in to the admin panel</p>

                {messages && messages.length > 0 && (
                    <>
                        {messages.map((message, index) => (
                            <div key={index}
                                 className={`alert alert-${message.level} alert-dismissible`}
                                 role="alert">
                                <div className="d-flex">
                                    <div>
                                        {message.level === 'success' ? (
                                            <i className="icon alert-icon ti ti-check"></i>
                                        ) : (
                                            <i className="icon alert-icon ti ti-alert-triangle"></i>
                                        )}
                                    </div>
                                    <div>
                                        {message.message}
                                    </div>
                                </div>
                                <button className="btn-close" data-bs-dismiss="alert"
                                        aria-label="close"></button>
                            </div>
                        ))}
                    </>
                )}

                <form onSubmit={this.handleSubmit} autoComplete="off" noValidate>
                    <div className="mb-3">
                        <label className="form-label">Email address</label>
                        <input
                            type="email"
                            className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                            placeholder="admin@example.com"
                            name="email"
                            value={formData.email}
                            onChange={this.handleInputChange}
                            autoComplete="off"
                        />
                        {errors.email && (
                            <div className="invalid-feedback">{errors.email}</div>
                        )}
                    </div>
                    <div className="mb-2">
                        <label className="form-label">
                            Password
                        </label>
                        <div className="input-group input-group-flat">
                            <input
                                type={showPassword ? 'text' : 'password'}
                                className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                                placeholder="Your password"
                                name="password"
                                value={formData.password}
                                onChange={this.handleInputChange}
                                autoComplete="off"
                            />
                            <span className="input-group-text">
                                <a
                                    href="#"
                                    className="link-secondary text-decoration-none"
                                    title="Show password"
                                    onClick={this.togglePasswordVisibility}
                                >
                                    <i className={`icon ti ${showPassword ? 'ti-eye-off' : 'ti-eye'}`}></i>
                                </a>
                            </span>
                            {errors.password && (
                                <div className="invalid-feedback">{errors.password}</div>
                            )}
                        </div>
                    </div>
                    <div className="form-footer">
                        <button type="submit"
                                className="btn btn-primary w-100"
                                disabled={isLoading}>
                            {isLoading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status"
                                          aria-hidden="true"></span>
                                    Signing in...
                                </>
                            ) : (
                                'Sign in'
                            )}
                        </button>
                    </div>
                    <div className="text-start mt-3">
                        <a className="fw-bold" href={this.getPasswordResetUrl()}>Forgot password?</a>
                    </div>
                </form>
            </AuthLayout>
        );
    }
}

export default AdminLogin;

if (container) {
    const root = createRoot(container);
    root.render(<AdminLogin/>);
}
